export default "__VITE_ASSET__Jxf_Of41__"